// extracted by mini-css-extract-plugin
module.exports = {"title":"vxuhXy","shine-lines":"EvC8SZ"};